<template>
  <div class="poster-share-btn-group">
    <div v-if="type === 'back'" class="poster-share-btn__back">
      <div @click.stop="$emit('onBack')">返回</div>
      <span>长按图片保存</span>
    </div>
    <div v-else class="poster-share-btn" @click.stop="$emit('onGeneratePoster')">
      {{ scene === "share" ? "查看我的成绩" : "生成海报" }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PosterShareButton',
  props: {
    type: {
      type: String,
      default: '' // "" | "back"
    },
    scene: {
      type: String,
      default: '' // "" | "share"
    }
  }
}
</script>

<style lang="scss" scoped>
.poster-share-btn-group {
  display: flex;
  justify-content: center;
  padding: 0.31rem 0.35rem;
  .poster-share-btn {
    width: 2.23rem;
    height: 0.75rem;
    line-height: 0.75rem;
    text-align: center;
    color: #ffffff;
    font-size: 0.3rem;
    font-weight: bold;
    border-radius: 0.38rem;
    background-image: linear-gradient(180deg, #ff9f00 0%, #ff601a 100%);
  }
  .poster-share-btn__back {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    & > div {
      background-color: rgba(0, 0, 0, 0.49);
      width: 1.63rem;
      height: 0.75rem;
      line-height: 0.75rem;
      text-align: center;
      color: #ffffff;
      font-size: 0.3rem;
      font-weight: bold;
      border-radius: 0.38rem;
    }

    & > span {
      font-size: 0.3rem;
      color: #ffffff;
    }
  }
}
</style>
